
import React from 'react';
import { Link } from 'react-router-dom';
import { Info, Github, Mail, Instagram, Film, Youtube } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-secondary/30 py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <img src="/logo.svg" alt="meyf-art Logo" className="h-8 w-auto" />
              <span className="ml-2 text-lg font-bold">meyf-art</span>
            </div>
            <p className="text-muted-foreground text-sm">
              Capturing life's most beautiful moments through professional videography.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-4">Connect</h3>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/thueringstagram/#" target="_blank" rel="noopener noreferrer" 
                className="text-muted-foreground hover:text-primary transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="www.youtube.com/@meyf-art" target="_blank" rel="noopener noreferrer" 
                className="text-muted-foreground hover:text-primary transition-colors">
                <Youtube className="h-5 w-5" aria-label="YouTube" />
              </a>
              <a href="https://vimeo.com/user2679012" target="_blank" rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors">
                <Film className="h-5 w-5" aria-label="Vimeo" />
              </a>
              <a href="https://github.com/Meyfster" target="_blank" rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors">
                <Github className="h-5 w-5" />
              </a>
              <a href="mailto:meyf@meyf-art.com"
                className="text-muted-foreground hover:text-primary transition-colors">
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-4">Impressum</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/imprint" className="text-muted-foreground hover:text-primary transition-colors flex items-center">
                  <Info className="h-4 w-4 mr-2" />
                  Imprint
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-muted-foreground hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-border mt-8 pt-8 text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} meyf-art. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
